import type { ReactNode } from 'react'

import LanguageMenu from '@components/LanguageMenu'
import { CheckoutHeader, CheckoutWrapper } from './CheckoutContainer.styled'

import LogoImage from '@assets/images/logo.svg'

type CheckoutContainerProps = {
  className?: string
  children?: ReactNode
  hideLanguage?: boolean
}

export const CheckoutContainer = ({ className, children, hideLanguage = false }: CheckoutContainerProps) => (
  <CheckoutWrapper className={className}>
    <CheckoutHeader>
      <span>
        <img src={LogoImage} alt='Logo' />
      </span>
      {hideLanguage ? null : <LanguageMenu />}
    </CheckoutHeader>

    {children}
  </CheckoutWrapper>
)
